import Pagination from '@mui/material/Pagination'
import { Box, TextField, IconButton } from '@mui/material'
import { ChevronLeft, ChevronRight } from '@mui/icons-material'
import { useState, useEffect } from 'react'

export const CustomPagination = ({ count, page, onChange, ...props }: any) => {
  const [inputPage, setInputPage] = useState(page || 1)

  // Sync input with external page changes
  useEffect(() => {
    setInputPage(page || 1)
  }, [page])

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    // Only allow positive integers
    if (value === '' || /^\d+$/.test(value)) {
      setInputPage(value === '' ? '' : parseInt(value, 10))
    }
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    const pageNumber = typeof inputPage === 'number' ? inputPage : parseInt(inputPage, 10)
    
    // Validate page number is within range
    if (pageNumber >= 1 && pageNumber <= count) {
      onChange(e, pageNumber)
    } else {
      // Reset to current page if invalid
      setInputPage(page || 1)
    }
  }

  const handlePrev = (e: React.MouseEvent) => {
    if (page > 1) {
      onChange(e, page - 1)
    }
  }

  const handleNext = (e: React.MouseEvent) => {
    if (page < count) {
      onChange(e, page + 1)
    }
  }
  return (
    <Box
      sx={{
        margin: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        flexWrap: 'wrap'
      }}
    >
      
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 0.5
        }}
      >
        <IconButton
          onClick={handlePrev}
          disabled={page === 1}
          size="small"
          sx={{
            '&:hover': {
              backgroundColor: '#c11b1e',
              color: 'white',
            },
            '&.Mui-disabled': {
              color: 'rgba(0, 0, 0, 0.26)'
            }
          }}
        >
          <ChevronLeft />
        </IconButton>

        <Box
          component="form"
          onSubmit={handleSubmit}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1
          }}
        >
          <TextField
            type="text"
            value={inputPage}
            onChange={handleInputChange}
            size="small"
            sx={{
              width: '70px',
              '& input': {
                textAlign: 'center',
                padding: '8px'
              }
            }}
            inputProps={{
              min: 1,
              max: count,
              'aria-label': 'Page number'
            }}
          />
        </Box>

        <IconButton
          onClick={handleNext}
          disabled={page === count}
          size="small"
          sx={{
            '&:hover': {
              backgroundColor: '#c11b1e',
              color: 'white',
            },
            '&.Mui-disabled': {
              color: 'rgba(0, 0, 0, 0.26)'
            }
          }}
        >
          <ChevronRight />
        </IconButton>
        <Box
          sx={{
            fontSize: '14px',
            color: 'text.secondary',
            whiteSpace: 'nowrap'
          }}
        >
          of <strong>{count?.toLocaleString('en') || 0}</strong>
        </Box>
      </Box>
    </Box>
  )
}